<template>

  <el-card class="box-card mb20 mt20 ml20 mr20  ">
    <div slot="header" class="clearfix">
      <span>印章申领</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="save" v-if="type == 1">暂存</el-button>
      <el-button style="float: right; padding: 3px 0" type="text" @click="back" v-if="type !== 1">返回上一步</el-button>
    </div>
    <official-apply ref="officialApply" :type.sync="type" :isRegistered.sync="isRegistered" @changeType="changeType" v-show="type === 1"/>
    <officialSeal :type.sync="type" :isRegistered.sync="isRegistered" v-show="type === 2"/>
    <OrderPayOff :type.sync="type" v-if="type === 3"/>
  </el-card>

</template>

<script>
import OfficialApply from "@/pages/customerEnterprise/components/OfficialApply.vue";
import OfficialSeal from "@/pages/customerEnterprise/components/OfficialSeal.vue";
import OrderPayOff from '@/pages/customerEnterprise/components/orderPayOff.vue';

export default {
  name: "record",
  components: {OfficialApply,OfficialSeal,OrderPayOff},
  data(){
    return {
      //
      type: 1,
      isRegistered: false,
    }
  },
  mounted() {
    let list = sessionStorage.getItem('FilingData')
    if (list){
      this.$refs.officialApply.getFilingData()
    }
  },
  methods:{
    save(){
      this.$refs.officialApply.handleSave()
    },
    back(){
      if (this.type > 1){
        this.type --
      }
    },
    changeType(type , isRegistered){
      if (type === 2){
        this.isRegistered = isRegistered
      }

      this.type = type
    }
  }
}
</script>

<style scoped lang="less">
.box-card{
  min-width: 850px;
}
</style>
